import { Button, Grid, Heading, Stack, Text } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import { useAuth } from '@/context/AuthContext'
import { DismissCircle, House, Logout } from '@/icons'

export const UnauthorizedPage = () => {
  const { user, logout } = useAuth()
  
  return (
    <Grid
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        height: 'calc(100vh - 4rem)',
      }}
    >
      <Stack gap={8} alignItems="center">
        <DismissCircle color="red.800" boxSize={24} />

        <Heading
          sx={{ fontSize: '2xl', fontWeight: 'medium', color: 'red.800' }}
          as="h2"
        >
          Neautorizovaný uživatel
        </Heading>

        {user?.logged && (
          <Stack gap={3}>
            <Text>
              Přihlášený uživatel:{' '}
              <Text as="span" fontWeight="bold">
                {user.userFullName}
              </Text>
            </Text>

            <Button as={Link} to={'/'} colorScheme="gray">
              <House />
              Na domovskou stránku
            </Button>

            <Button
              variant="ghost"
              colorScheme="gray"
              onClick={() => logout()}
            >
              <Logout />
              Odhlásit se
            </Button>
          </Stack>
        )}
      </Stack>
    </Grid>
  )
}
